export default {
  getPlans: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/plans/getters.js